export const getCostApiConfiguration = (userConfig) => {
    return {
        Type: userConfig.type,
        NumberOfSeats: userConfig.noOfSeats,
        Leg: userConfig.Legs,
        ElectricalManagementDown: userConfig["Raceway"],
        ElectricalManagementTop: userConfig["Wire Access"],
        ElectricalWireEntry: userConfig["Wire Entry"],
        SideModesty: userConfig["Side Modesty"],
        MainModesty: userConfig["Main Modesty"],
        MainScreen: userConfig["Main screen"],
        ReturnScreen: userConfig["Return screen"],
        Length: userConfig.Length,
        Height: userConfig.Height,
        Accessories: userConfig.Accessories,
        Pedestal: userConfig.Pedestal,
    };
};
